// extracted by mini-css-extract-plugin
module.exports = {"tableWrapper":"Table_tableWrapper__3lTRG","col":"Table_col__3_kZF","fulfillmentStatus":"Table_fulfillmentStatus__Yt2Ue","emailCol":"Table_emailCol__12avF"};